import React, { useEffect, useState } from 'react';

// LIBS
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import { cloneDeep } from 'lodash';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import axios from 'axios';

// SERVICES
import { cellPhoneMaskwithout55, maskCEP, maskCPF2, maskCnpj } from 'js/library/utils/helpers';
import phoneMaskArray from 'js/components/DesignSystem/phoneMaskArray.json';

// STYLES
import * as S from './styles';
import { Checkbox, Button, CircularProgress, MenuItem, Select, TextField } from '@mui/material';

// API
import { RegisterUsersBatch_v2 } from 'js/library/utils/API/apiRegisterUsersBatch';
import { addAccessList } from 'js/library/utils/API/apiAddAccessList';
import { checkUserPartnerCellphone } from 'js/library/utils/API/SearchUser/apicheckUserCellphone';

const UFs = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

const RegisterUserModalForm = (props) => {
  const { formFields, clubForms, clubInfo, formNotFound, modalClose } = props;
  const [clientForm, setClientForm] = useState({});
  const [inputMask, setInputMask] = useState('(99) 99999-9999');
  const [cellphone, setCellPhone] = useState('');
  const [currentDDD, setCurrentDDD] = useState('+55');
  const [isCepUnique, setIsCepUnique] = useState(true);
  const [currentCountry, setCurrentCountry] = useState('');
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const treatmentCep = (e) => {
    const inputValue = e.target.value;
    let sanitizedValue = inputValue.replace(/\D/g, '');
    if (sanitizedValue.length >= 9) {
      return;
    }

    if (sanitizedValue.length > 5) {
      sanitizedValue = sanitizedValue.replace(/(\d{5})(\d{1,3})/, '$1-$2');
    }
    setClientForm((prevClientForm) => ({
      ...prevClientForm,
      cep: sanitizedValue,
    }));
  };

  useEffect(() => {
    if (clientForm?.cep?.length === 9) {
      const formatedCEP = clientForm?.cep?.replace('-', '');
      axios
        .get(`https://viacep.com.br/ws/${formatedCEP}/json/`)
        .then((response) => {
          if (response.data.erro) {
            toast.error('CEP não encontrado!');
            setClientForm((prev) => ({
              ...prev,
              cep: '',
            }));
          }
          const data = response.data;
          const isGenericCep = !data.logradouro;

          setClientForm((prev) => ({
            ...prev,
            city: data.localidade,
            state: data.uf,
            neighborhood: data.bairro,
            streetAve: data.logradouro,
          }));
          setIsCepUnique(!isGenericCep);
        })
        .catch((error) => {
          console.error('CEP não encontrado.', error);
          toast.error('Insira um CEP válido!');
        });
    }
  }, [clientForm.cep]);

  const formatUserList = (formValues) => {
    let userInfoObj = {};
    let contactList = [];
    let documentList = [];
    let addressList = [];

    clubForms.formFields.forEach((field, index) => {
      switch (field.type) {
        case 'contactList':
          if (formValues[field.fieldName]) {
            contactList.push({
              type: field.fieldName,
              value: formValues[field.fieldName].toString(),
            });
          }
          userInfoObj.contactList = contactList;
          break;

        case 'documentList':
          if (formValues[field.fieldName]) {
            if (field.fieldType === 'cpf') {
              documentList.push({
                type: field.fieldName,
                value: formValues[field.fieldName].toString().replace(/\D+/g, ''),
              });
            } else {
              documentList.push({
                type: field.fieldName,
                value: formValues[field.fieldName].toString().replace(/\D+/g, ''),
              });
            }
            userInfoObj.documentList = documentList;
          }
          break;
        case 'addressList':
          if (formValues.cep) {
            addressList = [
              {
                zipCode: formValues.cep,
                streetAve: formValues.streetAve,
                neighborhood: formValues.neighborhood,
                number: formValues.number,
                city: formValues.city,
                state: formValues.state,
                extra: formValues.complement,
              },
            ];
            userInfoObj.addressList = addressList;
          }
          break;
        case 'others':
          if (formValues[field.fieldName]) {
            const fieldValue = formValues[field.fieldName];

            if (field.fieldName === 'aliasName') {
              userInfoObj[field.fieldName] = fieldValue;
            } else if (field.inputType === 'date' && fieldValue) {
              userInfoObj[field.fieldName] = new Date(fieldValue).getTime();
            }
          } else {
            userInfoObj[field.fieldName] = formValues[field.fieldName];
          }
          break;
        case 'root':
          if (formValues[field.fieldName]) {
            const fieldValue = formValues[field.fieldName];

            if (field.inputType === 'date' && fieldValue) {
              userInfoObj[field.fieldName] = new Date(fieldValue).getTime();
            } else {
              userInfoObj[field.fieldName] = fieldValue;
            }
          }
          break;
        default:
          break;
      }
    });

    userInfoObj.partnerId = clubInfo.partnerId;
    userInfoObj.partnerName = clubInfo.clubeId;

    const data = {
      partnerInfo: { ...userInfoObj },
      clubeId: clubInfo.clubeId,
      token:
        clubForms.tokenType === 'cpf'
          ? formValues[clubForms.tokenType].replace(/\D+/g, '')
          : formValues[clubForms.tokenType],
      cellphone: formValues.cellPhone,
      name: formValues.name,
    };
    return data;
  };

  function handleChange(e, key, mask) {
    let cloneClientForm = cloneDeep(clientForm);

    if (mask === 'cellPhone') {
      cloneClientForm[key] = cellPhoneMaskwithout55(e.target.value);
    } else if (mask === 'cep') {
      cloneClientForm[key] = maskCEP(e.target.value);
    } else if (mask === 'cpf') {
      cloneClientForm[key] = maskCPF2(e.target.value);
    } else if (mask === 'cnpj') {
      cloneClientForm[key] = maskCnpj(e.target.value);
    } else {
      cloneClientForm[key] = e.target.value;
    }
    setClientForm(cloneClientForm);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    let clientList = [clientForm];

    const filteredUserInfo = clientList.filter((row) => {
      if (row[clubForms.tokenType]) {
        return row;
      }
    }); // Filter para que venha apenas os usuários que possuem tokenType informados.

    if (filteredUserInfo.length === 0) {
      setLoading(false);
      return toast.error(
        `O ${
          clubForms.tokenType === 'cellPhone' ? 'número de celular' : clubForms.tokenType
        } é obrigatório`
      );
    }

    if (
      (!filteredUserInfo[0].cellPhone || filteredUserInfo[0].cellPhone.length < 14) &&
      formFields.filter((item) => item.fieldType === 'cellPhone').length === 1 &&
      !location.pathname.includes('seu-clube/permissoes-acesso')
    ) {
      setLoading(false);
      return toast.error('O número de celular é obrigatório');
    }

    if (clientForm.cpf && clientForm.cpf.length !== 14) {
      setLoading(false);
      return toast.error('CPF inválido!');
    }

    if (clientForm.cep) {
      if (
        !clientForm.streetAve ||
        !clientForm.state ||
        !clientForm.city ||
        !clientForm.number ||
        !clientForm.neighborhood
      ) {
        setLoading(false);
        return toast.error('Preencha todos os campos de endereço!');
      }
    }

    const formattedUsers = filteredUserInfo.map((client, index) => {
      return formatUserList(client);
    });

    const token = formattedUsers[0].token;

    const removeMask = (value) => {
      if (value.includes('@')) {
        // Se for email, aceita os caracteres
        return value.replace(/[^a-zA-Z0-9@()_.]/g, '');
      } else {
        return value.replace(/[^0-9+]/g, '');
      }
    };

    try {
      const cellphoneInput = filteredUserInfo[0].cellPhone;

      const validationCellphone = await checkUserPartnerCellphone(
        clubInfo.partnerId,
        removeMask(cellphoneInput)
      );

      if (validationCellphone.response.message === 'Usuário já vinculado ao partner') {
        setLoading(false);
        toast.error(`Celular já cadastrado no clube.`);
        return;
      }
    } catch (error) {
      setLoading(false);
    }

    if (location.pathname.includes('relacionamento/cadastro-usuarios')) {
      try {
        RegisterUsersBatch_v2(formattedUsers)
          .then((response) => {
            if (response.status === 200) {
              setLoading(false);
              toast.success(
                modalClose
                  ? 'Usuário cadastrados com sucesso! Em breve você poderá consultá-lo na aba "Editar lista de permissões".'
                  : 'Usuário cadastrados com sucesso! Em breve você poderá consultá-lo na aba "Ver meus clientes".'
              );
              setClientForm({});
              modalClose && modalClose();
            }
          })
          .catch((error) => {
            toast.error('Erro ao cadastrar usuários.');
            setLoading(false);
          });
      } catch (error) {
        toast.error('Ops, usuários não foram cadastrados.');
        setLoading(false);
      }
    } else {
      try {
        const payload = {
          usersPartnersData: [
            {
              partnerInfo: formattedUsers[0].partnerInfo,
              userPartnerId: removeMask(token),
            },
          ],
        };

        const response = await addAccessList(payload);

        if (response.message === 'Usuários adicionados com sucesso') {
          setLoading(false);
          toast.success('Usuário adicionado com sucesso à lista de acesso!');
          setClientForm({});
          modalClose && modalClose();
        } else {
          setLoading(false);
          toast.error('Erro ao adicionar usuário à lista de acesso.');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error during API call:', error);
        toast.error('Erro ao adicionar usuário à lista de acesso.');
      }
    }
  };

  const handleChangeCellphone = (event, key) => {
    let cloneClientForm = cloneDeep(clientForm);

    setCellPhone(event.target.value);

    if (event.target.value.length) {
      cloneClientForm[key] = '+' + (currentDDD + event.target.value).replace(/\D/g, '');
    } else if (!event.target.value.length) {
      delete cloneClientForm[key];
    }
    setClientForm(cloneClientForm);
  };

  function handleChangeCheck(key) {
    let cloneClientForm = cloneDeep(clientForm);

    if (!cloneClientForm[key]) {
      cloneClientForm[key] = true;
    } else if (cloneClientForm[key]) {
      cloneClientForm[key] = false;
    }
    setClientForm(cloneClientForm);
  }

  const handleCountryChange = (e) => {
    const valuesArr = e.target.value.split(',');
    setCellPhone('');
    setCurrentDDD(valuesArr[0]);
    setInputMask(valuesArr[1]);
    setCurrentCountry(e.target.value);
  };

  function fieldGenerator(field, index) {
    if (field.inputType === 'text') {
      if (field.fieldType === 'cellPhone') {
        return (
          <React.Fragment key={`fragment-${index}`}>
            {field.label}
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{
                startAdornment: (
                  <select
                    value={currentCountry}
                    onChange={handleCountryChange}
                    renderValue={(selected) => {
                      if (!selected) return 'Selecione';
                      const selectedCountry = phoneMaskArray.find(
                        (country) => country.ddd === selected[0]
                      );
                      return selectedCountry
                        ? `${selectedCountry.emoji} ${selectedCountry.initials} ${selectedCountry.ddd}`
                        : 'Selecione';
                    }}
                    style={{
                      fontFamily: "NotoColorEmojiLimited, 'Source Sans Pro', sans-serif",
                      height: '100%',
                      fontSize: '17px',
                      color: '#383838d6',
                      border: 'none',
                      outline: 'none',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      border: 'none',
                      marginLeft: '5px',
                    }}
                  >
                    {phoneMaskArray.map((country) => (
                      <option
                        key={country.id}
                        value={[country.ddd, country.mask, country.fullMask]}
                      >
                        {country.emoji} {country.initials} {country.ddd}
                      </option>
                    ))}
                  </select>
                ),
                inputComponent: InputMask,
                inputProps: {
                  mask: inputMask,
                  value: cellphone,
                  placeholder: inputMask,
                  onChange: (e) => handleChangeCellphone(e, field.fieldName),
                },
              }}
            />
          </React.Fragment>
        );
      }

      return (
        <React.Fragment key={`fragment-${index}`}>
          <span>
            {field.label}
            {field.fieldName === clubForms.tokenType &&
              location.pathname.includes('seu-clube/permissoes-acesso') && (
                <span> (Obrigatório)</span>
              )}
          </span>

          <TextField
            placeholder={field.label}
            value={clientForm[field.fieldName]}
            rows={1}
            type="text"
            onChange={(e) => {
              handleChange(e, field.fieldName, field.fieldType);
            }}
            fullWidth
            size="small"
          />
        </React.Fragment>
      );
    } else if (field.inputType === 'email') {
      return (
        <React.Fragment key={`fragment-${index}`}>
          {field.label}
          <TextField
            placeholder={field.label}
            value={clientForm[field.fieldName]}
            rows={1}
            type="email"
            onChange={(e) => {
              handleChange(e, field.fieldName, field.fieldType);
            }}
            size="small"
            fullWidth
          />
        </React.Fragment>
      );
    } else if (field.inputType === 'checkbox') {
      return (
        <React.Fragment key={`fragment-${index}`}>
          {field.label}
          <Checkbox
            checked={clientForm[field.fieldName]}
            onChange={() => handleChangeCheck(field.fieldName)}
          />
        </React.Fragment>
      );
    } else if (field.inputType === 'date') {
      return (
        <React.Fragment key={`fragment-${index}`}>
          {field.label}
          <TextField
            placeholder={field.label}
            value={clientForm[field.fieldName]}
            type="date"
            onChange={(e) => {
              handleChange(e, field.fieldName, field.fieldType);
            }}
            size="small"
            fullWidth
          />
        </React.Fragment>
      );
    } else if (field.inputType === 'address') {
      return (
        <>
          <React.Fragment key={`fragment-${index}`}>
            <label>CEP</label>
            <TextField
              id="outlined-basic"
              placeholder="99999-999"
              value={clientForm.cep || ''}
              onChange={treatmentCep}
              size="small"
              maxLength={9}
              fullWidth
            />
          </React.Fragment>
          {clientForm.cep && clientForm.cep.length === 9 && (
            <>
              <S.ContentInfoAddress>
                <S.ContentLabelAddress>
                  <label>Rua</label>
                  <TextField
                    placeholder="Rua"
                    disabled={isCepUnique}
                    value={clientForm.streetAve || ''}
                    onChange={(e) => handleChange(e, 'streetAve', 'text')}
                    size="small"
                    sx={{
                      backgroundColor: clientForm.streetAve ? '#f0f0f0' : 'white',
                    }}
                    fullWidth
                  />
                </S.ContentLabelAddress>
                <S.ContentLabelAddress>
                  <label>Número</label>
                  <TextField
                    placeholder="Número"
                    value={clientForm.number || ''}
                    onChange={(e) => handleChange(e, 'number', 'text')}
                    size="small"
                    fullWidth
                  />
                </S.ContentLabelAddress>
              </S.ContentInfoAddress>
              <S.ContentInfoAddress>
                <S.ContentLabelAddress>
                  <label>Bairro</label>
                  <TextField
                    placeholder="Bairro"
                    disabled={isCepUnique}
                    value={clientForm.neighborhood || ''}
                    onChange={(e) => handleChange(e, 'neighborhood', 'text')}
                    size="small"
                    sx={{
                      backgroundColor: clientForm.neighborhood ? '#f0f0f0' : 'white',
                    }}
                    fullWidth
                  />
                </S.ContentLabelAddress>
                <S.ContentLabelAddress>
                  <label>Cidade</label>
                  <TextField
                    placeholder="Cidade"
                    disabled={clientForm.city ? true : false}
                    value={clientForm.city || ''}
                    onChange={(e) => handleChange(e, 'city', 'text')}
                    size="small"
                    sx={{
                      backgroundColor: clientForm.city ? '#f0f0f0' : 'white',
                    }}
                    fullWidth
                  />
                </S.ContentLabelAddress>
                <S.ContentLabelAddress>
                  <label>UF</label>
                  <Select
                    id="uf-select"
                    value={clientForm.state || ''}
                    disabled={clientForm.state ? true : false}
                    onChange={handleChange}
                    size="small"
                    required
                    sx={{
                      backgroundColor: clientForm.state ? '#f0f0f0' : 'white',
                    }}
                  >
                    {UFs.map((uf) => (
                      <MenuItem key={uf} value={uf}>
                        {uf}
                      </MenuItem>
                    ))}
                  </Select>
                </S.ContentLabelAddress>
              </S.ContentInfoAddress>

              <label>Complemento</label>
              <TextField
                placeholder="Complemento"
                value={clientForm.complement || ''}
                onChange={(e) => handleChange(e, 'complement', 'text')}
                size="small"
                fullWidth
              />
            </>
          )}
        </>
      );
    }
  }

  if (formNotFound) {
    return (
      <S.ModalMessageContainer>
        {'Este clube ainda não está disponível para cadastro.'}
      </S.ModalMessageContainer>
    );
  }

  if (!formFields) {
    return (
      <S.ModalMessageContainer>
        {'Buscando formulário...'}
        <br />
        <CircularProgress />
      </S.ModalMessageContainer>
    );
  }

  return (
    <S.RegisterUnitForm
      onSubmit={(e) => {
        handleSubmit(e);
      }}
    >
      {formFields.map((form, index) => fieldGenerator(form, index))}{' '}
      {/* map para renderizar os campos do formulário */}
      <Button type="submit" variant="contained" color="primary" style={{ width: '6rem' }}>
        {loading ? <CircularProgress size="1.6rem" style={{ color: '#fff' }} /> : 'Cadastrar'}
      </Button>
    </S.RegisterUnitForm>
  );
};

export default RegisterUserModalForm;
